export const deprecatedColors = [
  'border-primary-on-fill',
  'border-primary-on-fill-default',
  'border-primary-subtle',
  'border-primary-subtle-default',
  'border-primary-subtle-hover',
  'border-primary-subtle-pressed',
  'border-surface-default',
  'fill-caution-alt',
  'fill-positive-alt',
  'fill-primary-subtle',
  'fill-secondary-subtle',
  'fill-surface-overlay',
  'fill-tertiary-alt',
  'fill-tertiary-subtle',
  'icon-accent-blue-default',
  'icon-accent-blue-on-fill-default',
  'icon-accent-blue-on-fill-subtle',
  'icon-accent-green-default',
  'icon-accent-green-on-fill-default',
  'icon-accent-green-on-fill-subtle',
  'icon-accent-magenta-default',
  'icon-accent-magenta-on-fill-default',
  'icon-accent-magenta-on-fill-subtle',
  'icon-accent-orange-default',
  'icon-accent-orange-on-fill-default',
  'icon-accent-orange-on-fill-subtle',
  'icon-accent-purple-default',
  'icon-accent-purple-on-fill-default',
  'icon-accent-purple-on-fill-subtle',
  'icon-accent-red-default',
  'icon-accent-red-on-fill-default',
  'icon-accent-red-on-fill-subtle',
  'icon-accent-teal-default',
  'icon-accent-teal-on-fill-default',
  'icon-accent-teal-on-fill-subtle',
  'icon-accent-yellow-default',
  'icon-accent-yellow-on-fill-default',
  'icon-accent-yellow-on-fill-subtle',
  'icon-alert-on-fill-subtle',
  'icon-brand-default',
  'icon-brand-on-fill-default',
  'icon-brand-on-fill-subtle',
  'icon-caution-default',
  'icon-caution-on-fill-alt',
  'icon-caution-on-fill-default',
  'icon-caution-on-fill-subtle',
  'icon-info-default',
  'icon-info-on-fill-default',
  'icon-info-on-fill-subtle',
  'icon-interactive-on-fill-subtle',
  'icon-positive-default',
  'icon-positive-on-fill-alt',
  'icon-positive-on-fill-default',
  'icon-positive-on-fill-subtle',
  'icon-primary-on-fill-default',
  'icon-primary-on-fill-subtle',
  'icon-secondary-subtle',
  'specialty-notification',
  'temp-do-not-use-border-primary-default',
  'temp-do-not-use-border-primary-disabled',
  'temp-do-not-use-fill-accent-teal-default',
  'temp-do-not-use-fill-accent-teal-hover',
  'temp-do-not-use-fill-accent-teal-pressed',
  'temp-do-not-use-fill-accent-teal-subtle',
  'temp-do-not-use-fill-field-hover',
  'temp-do-not-use-fill-field-pressed',
  'temp-do-not-use-fill-secondary-default',
  'temp-do-not-use-fill-secondary-hover',
  'temp-do-not-use-fill-secondary-pressed',
  'temp-do-not-use-fill-surface-default-hover',
  'temp-do-not-use-fill-surface-default-pressed',
  'temp-do-not-use-fill-surface-recessed',
  'temp-do-not-use-icon-primary-default',
  'temp-do-not-use-icon-primary-hover',
  'temp-do-not-use-icon-primary-pressed',
  'temp-do-not-use-reporting-fill-highlight-purple-subtle',
  'temp-do-not-use-specialty-scrim',
  'temp-do-not-use-text-primary-default',
  'temp-do-not-use-text-primary-subtle',
  'text-accent-blue-default',
  'text-accent-blue-on-fill-default',
  'text-accent-blue-on-fill-subtle',
  'text-accent-green-default',
  'text-accent-green-on-fill-default',
  'text-accent-green-on-fill-subtle',
  'text-accent-magenta-default',
  'text-accent-magenta-on-fill-default',
  'text-accent-magenta-on-fill-subtle',
  'text-accent-purple-default',
  'text-accent-purple-on-fill-default',
  'text-accent-purple-on-fill-subtle',
  'text-accent-red-default',
  'text-accent-red-on-fill-default',
  'text-accent-red-on-fill-subtle',
  'text-accent-teal-default',
  'text-accent-teal-on-fill-default',
  'text-accent-teal-on-fill-subtle',
  'text-accent-yellow-default',
  'text-accent-yellow-on-fill-default',
  'text-accent-yellow-on-fill-subtle',
  'text-alert-on-fill',
  'text-alert-on-fill-subtle',
  'text-brand-on-fill-default',
  'text-brand-on-fill-subtle',
  'text-caution-default',
  'text-caution-on-fill-alt',
  'text-caution-on-fill-default',
  'text-caution-on-fill-subtle',
  'text-info-default',
  'text-info-on-fill-default',
  'text-info-on-fill-subtle',
  'text-interactive-on-fill-subtle',
  'text-positive-default',
  'text-positive-on-fill-alt',
  'text-positive-on-fill-default',
  'text-positive-on-fill-subtle',
  'text-primary-on-fill-default',
  'text-primary-on-fill-subtle',
];
